import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';

export class ArquivosManager {
  TAMANHO_MAXIMO_ARQUIVOS = 5242880;
  NUMERO_MINIMO_ARQUIVOS_IDENTIFICACAO = 1;
  NUMERO_MAXIMO_ARQUIVOS_IDENTIFICACAO = 4;
  ANEXO_DOCUMENTO_IDENFITICACAO = 'anexo_documento_identificacao';
  ANEXO_DOCUMENTO_OUTROS = 'anexo_documento_outros';
  ANEXO_FOTO_IDENTIFICACAO = 'anexo_foto_identificacao';
  ANEXO_DOCUMENTO_JUIZ = 'anexo_documento_juiz';
  DECLARACAO_VERACIDADE_ACEITE = 'declaracao_veracidade_aceite';

  anexos: { [key: string]: File[] } = {};

  onFileSelect(event: FileSelectEvent, campo: string) {
    this.anexos[campo] = event.currentFiles;
  }

  onFileRemove(event: FileRemoveEvent, campo: string) {
    this.anexos[campo] = [
      ...this.anexos[campo].filter((curr) => curr != event.file),
    ];
  }

  onClearFiles($event: Event, campo: string) {
    this.inicializarCategoriaArquivo(campo);
  }

  inicializarCategoriaArquivo(campo: string) {
    this.anexos[campo] = [];
  }

  isCategoriaFilled(campo: string): boolean {
    return this.anexos[campo].length > 0;
  }
}
